<template>
  <div
    class="benefits-container flex-column l:flex-row flex-center-middle gap-max bg-bg padding-l-vertical">
    <div class="benefit flex-column flex-middle flex-between">
      <div class="flex-column flex-middle">
        <icon
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="hide animate--delay-100"
          size="3.5"
          icon="buyer-benefits" />
        <h2
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="margin-m-vertical animate--delay-200 hide">
          {{ t("justopp.benefits.buyers.title") }}
        </h2>
        <p
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="hide animate--delay-300">
          {{ t("justopp.benefits.buyers.description") }}
        </p>
      </div>
      <saffron-link
        :to="{ name: isLoggedIn ? 'user-dashboard' : 'user-register' }"
        class="plain-link">
        <form-button
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="width-200 buyer animate--delay-400 gap-l flex-center flex-middle hide"
          theme="lead"
          >{{ t("justopp.benefits.buyers.cta") }}
        </form-button>
      </saffron-link>
    </div>

    <div class="benefit flex-column flex-middle flex-between">
      <div class="flex-column flex-middle">
        <icon
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="hide animate--delay-100"
          size="3.5"
          icon="seller-benefits" />
        <h2
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="margin-m-vertical hide animate--delay-200">
          {{ t("justopp.benefits.sellers.title") }}
        </h2>
        <p
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="hide animate--delay-300">
          {{ t("justopp.benefits.sellers.description") }}
        </p>
      </div>
      <saffron-link
        :to="
          userVendor
            ? { name: 'company-vendorId-dashboard', params: { vendorId: userVendor.id } }
            : { name: 'vendor-register' }
        "
        class="plain-link">
        <form-button
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="width-200 seller animate--delay-400 gap-l flex-center flex-middle hide"
          theme="lead-inverse"
          >{{ t("justopp.benefits.sellers.cta") }}
        </form-button>
      </saffron-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Benefits",
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    userVendor() {
      if (!this.userProfile) {
        return false;
      }

      if (!this.userProfile.Vendor) {
        return false;
      }

      return this.userProfile.Vendor;
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-container {
  @media (min-width: 1024px) {
    align-items: flex-start;
    gap: calc(var(--margin-max) * 5.5) !important;
  }
}

.benefit {
  width: 280px;

  @media (min-width: 1024px) {
    width: 380px;
    height: 380px;
    margin-bottom: calc(var(--margin-max) * 1.75);
  }

  .seller {
    color: var(--c-inverse) !important;
  }

  .seller,
  .buyer {
    font-size: var(--font-l);
    margin-top: var(--margin-l);
  }
}

.hide {
  opacity: 0;
}
</style>
